
import {Options, Vue} from 'vue-class-component';
import {mapGetters} from 'vuex'

@Options({
  props: {
    msg: String,
    AboutUs: String,
    AboutUsText: String,
    OurTeam: String,
    OurTeamText: String,
    OurProduct: String,
    OurProductText: String,
  },
  computed: {
    ...mapGetters(['getJsonData', 'getTheme']),
    jsonData() {
      const jsonData = this.getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, "<br>");
      return JSON.parse(jsonDataWithBreaks);
    },
    logoSrc() {
      return this.getTheme === 'light'
        ? require('../assets/logo_dark.png')
        : require('../assets/logo_wight.png');
    }
  }
})
export default class Logo extends Vue {
  msg!: string
}
